module.exports = __webpack_public_path__ + "static/logo-7d0bfeb2a86214447f01ad4ef3376773.png";